export default "__VITE_ASSET__579bce99__"